@if (registroNaoSelecionado) {
    <app-empty [titulo]="'Registro não selecionado'" [descricao]="'Por favor, selecione um registro para visualizar os dados'" [acao]="abrirPesquisaRegistro" [iconBotao]="'pi pi-search'" [labelBotao]="'Selecionar Registro'"></app-empty>
} @else {
    <div class="solicitar-layout">
        <div class="solicitar-grid" [class.tem-impedimentos]="(validacao?.impedimentos?.length ?? 0) > 0">
            @if ((validacao?.impedimentos?.length ?? 0) > 0) {
                <aside class="impedimentos-card">
                    <div class="feedback-title">Impedimentos identificados</div>
                    <ul>
                        @for (impedimento of validacao?.impedimentos ?? []; track impedimento) {
                            <li>{{ impedimento }}</li>
                        }
                    </ul>
                </aside>
            }

            <app-card-content class="solicitar-card-principal" [icon]="'pi pi-send'" [title]="'Nova Solicitação'" [subtitle]="'Solicitar Inscricao Secundaria ou Transferencia'">
                <div [formGroup]="formSolicitacao">
                    @if (validacao) {
                        <div class="validacao-painel">
                            @if (tiposSolicitacaoDisponiveis.length) {
                                <div class="tipo-solicitacao-bloco">
                                    <div class="field">
                                        <label>Tipo de Solicitação</label>
                                    </div>

                                    <div class="tipo-solicitacao-grid">
                                        @for (tipo of tiposSolicitacaoDisponiveis; track tipo.value) {
                                            <button type="button" class="tipo-solicitacao-card" [class.selecionado]="isTipoSolicitacaoSelecionado(tipo.value)" (click)="selecionarTipoSolicitacao(tipo.value)">
                                                <div class="tipo-solicitacao-texto">
                                                    <strong>{{ tipo.value === 'S' ? 'Secundaria' : 'Transferencia' }}</strong>
                                                    <small>{{ obterDescricaoTipoSolicitacao(tipo.value) }}</small>
                                                </div>
                                                <span class="tipo-solicitacao-indicador" aria-hidden="true"></span>
                                            </button>
                                        }
                                    </div>

                                    <div class="form-grid">
                                        <div class="field">
                                            <label>UF Destino</label>
                                            <app-estado-select [uf]="formSolicitacao.controls.ufDestino.value" [removeBR]="true" [ufsPermitidas]="ufsDestinoPermitidas" (ufChange)="onUfDestinoChange($event)"></app-estado-select>
                                        </div>
                                    </div>

                                    <div class="acoes-solicitar">
                                        <p-button
                                            type="button"
                                            icon="pi pi-send"
                                            label="Solicitar"
                                            [loading]="carregandoSolicitacao()"
                                            [disabled]="carregandoValidacao() || carregandoSolicitacao() || bloquearSolicitacaoPorUf"
                                            (onClick)="solicitar()"
                                            [appCan]="roleCentralSolicitar"
                                        ></p-button>
                                    </div>
                                    @if (bloquearSolicitacaoPorUf) {
                                        <div class="feedback">Solicitação bloqueada: a UF da pessoa pesquisada é diferente da UF do usuário logado.</div>
                                    }
                                </div>
                            } @else {
                                <div class="feedback">Nenhum tipo de inscrição está disponível para solicitação.</div>
                            }
                        </div>
                    }
                </div>
            </app-card-content>
        </div>

        @if (retornoSolicitacao) {
            <app-card-content class="retorno-card" [headerColor]="false" [icon]="'pi pi-check-circle'" [title]="'Retorno da Solicitacao'" [subtitle]="'Resumo dos dados da solicitacao gerada'">
                <div class="retorno-destaques">
                    <div class="retorno-highlight retorno-highlight-id">
                        <span class="retorno-highlight-label">ID</span>
                        <strong class="retorno-highlight-valor">{{ retornoSolicitacao.idSolicitacao ?? '-' }}</strong>
                    </div>
                    <div class="retorno-highlight retorno-highlight-tipo">
                        <span class="retorno-highlight-label">Tipo</span>
                        <strong class="retorno-highlight-valor">{{ obterDescricaoTipo(retornoSolicitacao) }}</strong>
                    </div>
                    <div class="retorno-highlight retorno-highlight-validade">
                        <span class="retorno-highlight-label">Data Validade</span>
                        <strong class="retorno-highlight-valor">{{ formatarData(retornoSolicitacao.dataValidade) }}</strong>
                    </div>
                </div>

                <div class="retorno-destaques retorno-destaques-secundarios">
                    <div class="retorno-highlight">
                        <span class="retorno-highlight-label">UF Destino</span>
                        <strong class="retorno-highlight-valor retorno-uf">
                            @if (obterBandeiraUf(retornoSolicitacao.ufDestino); as bandeiraUfDestino) {
                                <img [src]="bandeiraUfDestino" [alt]="formatarUf(retornoSolicitacao.ufDestino)" class="uf-flag" />
                            }
                            <span class="retorno-uf-label">{{ formatarUf(retornoSolicitacao.ufDestino) }}</span>
                        </strong>
                    </div>
                    <div class="retorno-highlight retorno-highlight-status">
                        <span class="retorno-highlight-label">Status</span>
                        <strong class="retorno-highlight-valor">{{ obterDescricaoStatus(retornoSolicitacao) }}</strong>
                    </div>
                    <div class="retorno-highlight">
                        <span class="retorno-highlight-label">Data Solicitação</span>
                        <strong class="retorno-highlight-valor">{{ formatarData(retornoSolicitacao.dataSolicitacao) }}</strong>
                    </div>
                </div>
            </app-card-content>
        }
    </div>
}
